export const LAYERS = [
  {
    id: 1,
    name: '表面观感',
    title: '第一层：表面观感（浅层）',
    description: '你的直觉反应，无需理论',
    difficulty: 'easy',
    icon: '👁️',
    sections: [
      {
        id: 'emotion',
        title: '情感维度',
        questions: [
          '这一幕让我感到什么？（感动/愤怒/困惑/不适/兴奋）',
          '哪个人物的处境让我最有共鸣？为什么？',
          '我希望发生什么？（不是剧中发生了什么，而是我期待什么）'
        ]
      },
      {
        id: 'aesthetic',
        title: '审美维度',
        questions: [
          '这一幕的镜头/演技/台词打动我吗？',
          '如果去掉音乐和演员表演，还会感动吗？'
        ]
      },
      {
        id: 'story',
        title: '故事直觉',
        questions: [
          '我预测接下来会发生什么？',
          '这个转折合理吗？',
          '这一幕是否改变了我对某个人物的看法？'
        ]
      }
    ]
  },
  
  {
    id: 2,
    name: '具体分析',
    title: '第二层：具体分析（中浅层）',
    description: '开始细看"怎样"和"为什么"',
    difficulty: 'medium',
    icon: '🔍',
    sections: [
      {
        id: 'character',
        title: '人物维度',
        questions: [
          '在这一幕中，谁掌握主动权？（谁说话、谁沉默；谁决定、谁被决定）',
          '权力如何通过身体表现？（站立/跪下；靠近/保持距离；看着/被看）',
          '低权力者有无反抗？是什么样的反抗？（激烈对抗/沉默抵抗/微妙转身）',
          '每个人物的表情、语调说了什么？（言语与非言语一致吗？）',
          '谁在隐瞒？谁在表露？',
          '有无自我欺骗的时刻？（说着一回事，做着另一回事）',
          '为什么他在这一刻做出这个选择？',
          '有其他选择吗？为什么不选？',
          '这个选择付出了什么代价？'
        ]
      },
      {
        id: 'plot',
        title: '情节维度',
        questions: [
          '这一幕的核心冲突是什么？（是权力对立、观念分歧、还是各有责任？）',
          '冲突是二元对立（A vs B）还是多维的？',
          '这个冲突能解决吗？怎样解决？',
          '说了什么？隐瞒了什么？',
          '谁知道什么？谁被蒙在鼓里？',
          '这个信息差如何推动情节？',
          '这一幕发生在剧情的什么关键位置？',
          '如果这一幕早发生/晚发生，会改变什么？'
        ]
      },
      {
        id: 'detail',
        title: '细节维度',
        questions: [
          '哪句话最有力量？为什么？',
          '有无双关语、讽刺或言外之意？',
          '某个词反复出现吗？每次出现语境不同吗？',
          '背景里有什么？（宫殿的压迫感？窗外的自由？）',
          '两人的位置关系说了什么？（靠近/远离；上/下；明亮/阴影）',
          '颜色变化了吗？（从冷色到暖色？从明亮到昏暗？）',
          '有配乐吗？什么时候有，什么时候没有？',
          '配乐如何强化了情感？',
          '有沉默的时刻吗？沉默说了什么？'
        ]
      }
    ]
  },
  
  {
    id: 3,
    name: '理论审视',
    title: '第三层：理论审视（中层）',
    description: '用理论工具重新看，发现更复杂的真相',
    difficulty: 'hard',
    icon: '🧠',
    sections: [
      {
        id: 'theory-selection',
        title: '选择理论工具',
        questions: [
          '你想用哪个理论工具来分析这一幕？（权力/性别/现代性/后殖民/个人与结构）'
        ]
      }
    ]
  },
  
  {
    id: 4,
    name: '综合反思',
    title: '第四层：综合反思（深层）',
    description: '多个理论工具的对话与碰撞',
    difficulty: 'hard',
    icon: '🌀',
    sections: [
      {
        id: 'multi-perspective',
        title: '多视角对话',
        questions: [
          '不同理论对这一幕有什么不同的解读？',
          '这些解读是否矛盾？如何共存？',
          '我倾向哪种解读？为什么？',
          '是否可能同时接纳多个答案？'
        ]
      }
    ]
  },
  
  {
    id: 5,
    name: '终极反思',
    title: '第五层：终极反思（最深层）',
    description: '从看剧回到看自己',
    difficulty: 'expert',
    icon: '🪞',
    sections: [
      {
        id: 'self-reflection',
        title: '自我对话',
        questions: [
          '这部剧成为了我的什么？',
          '我认同了什么？抵触了什么？',
          '如果你处于其中一个角色的位置，你会怎样选择？',
          '这个故事对我现在的生活有什么意义？'
        ]
      }
    ]
  }
];
